import { AxiosInstance } from "axios";
import { CategoryListProps } from "./interfaces/CategoryInterface";
import { ActivityListProps } from "../interfaces/ActivityInterface";

class HomeUseCase {
  client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  getCategories(): CategoryListProps {
    return {
      categories: [
        { name: "Events" },
        { name: "Restaurant Promotions" },
        { name: "Lifestyle Applications" },
      ],
    };
  }

  getPopularActivities(): ActivityListProps {
    return {
      activities: [
        {
          id: "1",
          category: "Restaurant Promotions",
          name: "Momo paradise",
          announce: "Come 4 Pay 3",
          imageUrl: "https://svgshare.com/i/QTc.svg",
          description:
            "Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
        },
        {
          id: "2",
          category: "Events",
          name: "Flutter Class",
          location: "Agoda 44th fl., Central World",
          announce: "MON, 7 SEP 2020",
          imageUrl: "https://svgshare.com/i/QTc.svg",
          description:
            "Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
        },
        {
          id: "3",
          category: "Lifestyle Applications",
          name: "Netflix Family",
          announce: "99 Baths / month",
          imageUrl: "https://svgshare.com/i/QTc.svg",
          description:
            "Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
        },
        {
          id: "4",
          name: "hihi momo",
          category: "Restaurant Promotions",
          announce: "Come 4 Pay 3",
          location: " ",
          imageUrl: "https://svgshare.com/i/QTc.svg",
          description:
            "Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
        },
        {
          id: "5",
          name: "eiei za flutter",
          category: "Events",
          location: "Agoda",
          announce: "MON, 7 SEP 2020",
          imageUrl: "https://svgshare.com/i/QTc.svg",
          description:
            " Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
        },
        {
          id: "6",
          name: "Spotify Family",
          category: "lifestyle applications",
          location: " ",
          announce: "99 Baths / month",
          imageUrl: "https://svgshare.com/i/QTc.svg",
          description:
            "Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
        },
      ],
    };
  }
}

export default HomeUseCase;
